import type { NavSectionToken, Theme } from 'hephaestus/core';
import { merge } from 'lodash-es';

export const useNavSectionTokens = (theme: Theme): NavSectionToken => {
  const { color, component } = theme;
  const base = {
    color: color.onSurface,
    backgroundColor: color.surface,
    hoverColor: color.primaryVariantHover,
    selectedColor: color.primaryVariant,
    radius: '8px',
  };

  return merge({}, base, component?.navSection) as NavSectionToken;
};
